/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '${url}/api';
}

/**
 * Parameters for `PublicApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
